import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useQuery, gql } from '@apollo/client'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'
import InquiryContainer from './InquiryContainer'

// Breadcrumb context for an order: its customer and the customer's companies.
// `order(number:)` keys on the order number (the route :id).
const ORDER_BREADCRUMB_QUERY = gql`
  query OrderBreadcrumb($number: String!) {
    order(number: $number) {
      id
      number
      customer {
        id
        customerNo
        fullName
        companies {
          id
          name
        }
      }
    }
  }
`

const InquiryPage = ({ match }) => {
    const { id } = match.params

    useEffect(() => {
        document.title = `${id} | OSH CRM`
    }, [id])

    const { data } = useQuery(ORDER_BREADCRUMB_QUERY, { variables: { number: id } })
    const order = data && data.order
    const customer = order && order.customer
    const companies = (customer && customer.companies) || []
    const first = companies[0]

    // Company crumb links the first company; a dropdown (`menu`) lists them all
    // when the customer belongs to more than one.
    const companyCrumb = first
        ? {
            path: `/companies/${first.id}`,
            name: first.name,
            menu: companies.length > 1
                ? companies.map((c) => ({ path: `/companies/${c.id}`, name: c.name }))
                : undefined
        }
        : null

    const customerCrumb = customer
        ? {
            path: `/customers/${customer.customerNo}`,
            name: `${customer.customerNo} · ${customer.fullName || ''}`.trim().replace(/·\s*$/, '').trim()
        }
        : null

    const breadcrumbs = [
        { path: '/order_summaries', name: 'Orders' },
        ...(companyCrumb ? [companyCrumb] : []),
        ...(customerCrumb ? [customerCrumb] : []),
        { path: `/inquiries/${id}`, name: id }
    ]

    return (
        <Layout>
            <LayoutContentWrapper breadcrumbs={breadcrumbs}>
                <ContentLayout>
                    <InquiryContainer id={id} />
                </ContentLayout>
            </LayoutContentWrapper>
        </Layout>
    )
}

InquiryPage.propTypes = {
    match: PropTypes.object.isRequired
}

export default InquiryPage
